import I18n from '@shared/js/i18n/I18n';

const $I18n = new I18n();

export default $I18n;
